/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

const locale = {
  placeholder: 'ÐÐ±ÐµÑÑÑÑ ÑÐ°Ñ'
};

export default locale;
